import { UploadFile } from 'antd';
import React, { ChangeEvent, FormEvent, useState } from 'react';
import FloatingButton from '../../buttons/FloatingButton';
import FileUpload from '../../inputs/fileupload/FileUpload';
import Textarea from '../../inputs/text/Textarea';

interface Props {
  onSubmit: (comment: string, file?: UploadFile[]) => void;
  allowAttachments?: number;
  loading?: boolean;
}

const CommentForm = ({
  onSubmit,
  allowAttachments,
  loading = false,
}: Props) => {
  const [comment, setComment] = useState('');
  // const [loading, setLoading] = useState(0);
  const [file, setFile] = useState<UploadFile[]>([]);

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setComment('');
    setFile([]);
    onSubmit(comment, file);
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setComment(event.target.value);
  };

  return (
    <form
      onSubmit={handleSubmit}
      className={`${loading ? 'animate-pulse bg-gradient-to-r' : ''} `}
    >
      <div className="relative">
        <Textarea
          style="buttonInline"
          placeholder={loading ? 'Verzenden...' : 'Comment versturen'}
          name="com_commentaar"
          onChange={handleChange}
          value={comment}
        />

        <FloatingButton icon="send" position="right" loading={loading} />
      </div>

      <div className="mt-5">
        <FileUpload
          name="attachment"
          onChange={setFile}
          fileTypes={['image/jpg', 'image/jpeg', 'image/png']}
          fileList={file}
          description="Voeg bijlagen toe"
          style="min"
          allowAttachments={allowAttachments}
        />
      </div>
    </form>
  );
};

export default CommentForm;
